import React, { useEffect, useState } from 'react';
import apiService from 'services/apiService';
import { storageService } from 'services/storageService';
import { toast } from 'react-toastify';

interface User {
  id: number;
  first_name: string;
  last_name: string;
  reg_id: number;
}

interface SendNotificationProps {
  userId: any;
  role: 'Client' | 'Operator';
}

const SendNotification: React.FC<SendNotificationProps> = ({ userId, role }) => {
  const [message, setMessage] = useState('');
  const [users, setUsers] = useState<User[]>([]);
  const [selectedRegId, setSelectedRegId] = useState<number | null>(null);
  const [isSending, setIsSending] = useState(false);

  // Fetch users when component mounts if role is Operator
  useEffect(() => {
    if (role === 'Operator') {
      const fetchUsers = async () => {
        try {
          const res = await apiService.get('registrations');
          console.log('res.data' ,res.data)
          console.log('userId',userId)
          setUsers([...res.data.filter((dat:any)=>dat.operator_id===userId)]);
        } catch (error) {
          console.error('Failed to fetch users:', error);
          toast.error('Failed to load users');
        }
      };

      fetchUsers();
    }
  }, [role,userId]);

  const handleSend = async () => {
    if (!message.trim()) {
      toast.warning('Please enter a message');
      return;
    }

    if (role === 'Operator' && !selectedRegId) {
      toast.warning('Please select a user');
      return;
    }

    setIsSending(true);
    try {
      let userdetails:any=storageService.getItem('userdetails')
      await apiService.post('notification/send', {
        reg_id: role === 'Operator' ? selectedRegId : userId,
        sent_by: role === "Operator" ? 0 : 1, // 0=Operator, 1=User
        send_notification: message,
        operator_id: role === 'Operator' ? userId : JSON.parse(userdetails).user.operator_id,
        sent_date: Math.floor(Date.now() / 1000),
      });
      setMessage('');
      setSelectedRegId(null);
      toast.success('Message sent successfully! Email notification has been sent.');
      
      // Refresh the page to show new message
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } catch (error) {
      console.error('Failed to send notification:', error);
      toast.error('Failed to send message. Please try again.');
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="send-notification-container">
      

      {/* Header Row */}
      <div className="header-row">
        <h3>Send a Notification</h3>
      </div>

      {/* Dropdown and Message Input Row */}
      <div className="input-row">
        {/* Dropdown for selecting user if role is Operator */}
        {role === 'Operator' && (
          <div className="select-container">
            <label htmlFor="userSelect">Select User:</label>
            <select
              id="userSelect"
              value={selectedRegId ?? ''}
              onChange={(e) => setSelectedRegId(Number(e.target.value))}
            >
              <option value="">Select a user</option>
              {users.map((user) => (
                <option key={user.reg_id} value={user.reg_id}>
                  {`${user.first_name} ${user.last_name}`}
                </option>
              ))}
            </select>
          </div>
        )}

        {/* Textarea for message */}
        <div className="textarea-container">
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Enter your message here"
          ></textarea>
        </div>

        {/* Send Button */}
        <div className="button-container text-center rounded-lg">
          <button 
            onClick={handleSend} 
            disabled={(role === 'Operator' && !selectedRegId) || isSending || !message.trim()}
            className={`px-6 py-2 rounded-lg font-semibold transition-colors ${
              (role === 'Operator' && !selectedRegId) || isSending || !message.trim()
                ? 'bg-gray-400 cursor-not-allowed' 
                : 'bg-blue-600 hover:bg-blue-700 text-white'
            }`}
          >
            {isSending ? 'Sending...' : 'Send Message'}
          </button>
        </div>
      </div>
      <p className="text-sm text-gray-600 mt-2 text-center">
        📧 {role === 'Operator' ? 'User' : 'Your operator'} will receive an email notification about your message
      </p>
    </div>
  );
};

export default SendNotification;
